import { render, staticRenderFns } from "./BeerList.vue?vue&type=template&id=4a6a2ac8&scoped=true&lang=html&"
import script from "./BeerList.vue?vue&type=script&lang=js&"
export * from "./BeerList.vue?vue&type=script&lang=js&"
import style0 from "./BeerList.vue?vue&type=style&index=0&id=4a6a2ac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6a2ac8",
  null
  
)

export default component.exports